export * from '@primeuix/themes/material/treeselect';
export { default } from '@primeuix/themes/material/treeselect';
